<template>
  <div class="mono-json-edit">
    <div v-if="!readOnly" class="mono-json-edit__toolbar">
      <el-button size="small" type="primary" plain @click="formatJson">格式化 JSON</el-button>
      <span v-if="error" class="mono-json-edit__error">{{ error }}</span>
    </div>
    <MonoEdit
      :model-value="modelValue"
      :height="height"
      :read-only="readOnly"
      :theme="theme"
      language="json"
      @update:model-value="onUpdate"
    />
  </div>
</template>

<script>
import MonoEdit from '@/components/MonoEdit.vue'
import { validateExamJsonField } from '@/utils/examJson'

export default {
  name: 'MonoJsonEdit',
  components: { MonoEdit },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    height: {
      type: [String, Number],
      default: 'min(48vh, 520px)'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'vs-light'
    },
    /** 校验失败时提示前缀，如「原始题目」 */
    fieldLabel: {
      type: String,
      default: 'JSON'
    }
  },
  emits: ['update:modelValue', 'validity'],
  data() {
    return {
      error: ''
    }
  },
  methods: {
    onUpdate(val) {
      this.error = ''
      this.$emit('update:modelValue', val ?? '')
      this.$emit('validity', true)
    },
    formatJson() {
      const result = validateExamJsonField(this.modelValue, this.fieldLabel, { allowEmpty: true })
      if (!result.ok) {
        this.error = result.message
        this.$emit('validity', false)
        return
      }
      this.error = ''
      this.$emit('update:modelValue', result.value)
      this.$emit('validity', true)
    },
    /** 提交前调用：格式化并校验，失败抛错 */
    ensureValid() {
      const result = validateExamJsonField(this.modelValue, this.fieldLabel, {
        allowEmpty: false
      })
      if (!result.ok) {
        this.error = result.message
        this.$emit('validity', false)
        throw new Error(result.message)
      }
      if (result.value !== this.modelValue) {
        this.$emit('update:modelValue', result.value)
      }
      this.error = ''
      this.$emit('validity', true)
      return result.value
    }
  }
}
</script>

<style scoped>
.mono-json-edit {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.mono-json-edit :deep(.mono-edit) {
  width: 100%;
  max-width: 100%;
}

.mono-json-edit__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.mono-json-edit__error {
  font-size: 12px;
  color: var(--el-color-danger);
}
</style>
